import React, { useEffect, useState } from 'react';
import * as _ from 'lodash';
import { Instagram, LocationOn } from '@material-ui/icons';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../contexts/auth.context';
import axios from 'axios';

const GalleryComponent = () => {
  const [photos, setPhotos] = useState();
  const { locations } = useAuth();
  const [once, setOnce] = useState(false);

  const containerVariants = {
    hidden: {
      opacity: 0,
      y: '-100vh'
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: 'easeInOut',
        delay: 0
      }
    },
    exit: {
      x: '-100vw',
      opacity: 0,
      transition: {
        ease: 'easeInOut',
        delay: 0,
        duration: 1
      }
    }
  };

  const instagramApi = {
    getPublicImages: async (
      locationId,
      accessToken,
      locationName,
      socialMedia
    ) => {
      const apiUrl = `https://graph.instagram.com/me/media?fields=id,media_url,media_type&access_token=${accessToken}`;
      await axios.get(apiUrl).then((res) => {
        const data = res.data.data;
        const mediaArray = [];
        data.map((media) => {
          mediaArray.push({ url: media.media_url, type: media.media_type });
        });
        setPhotos((old) => ({
          ...old,
          [locationId]: { mediaArray, locationName, socialMedia }
        }));
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (locations && !once) {
      setOnce(true);
      locations.map((location) => {
        console.log(location);
        if (location.gallery) {
          instagramApi.getPublicImages(
            location.locationName.split(' ').join('-').toLowerCase(),
            location.gallery,
            location.locationName,
            location.socialMedia
          );
        }
      });
    }
  }, [locations]);

  return (
    <motion.section
      variants={containerVariants}
      initial='hidden'
      animate='visible'
      exit='exit'
      id='gallery'
    >
      <Helmet>
        <meta
          name='description'
          content='Unsere Arbeiten, Professionelle Tattoos, Piercings, Haare & Make-up  in Stuttgart-Mitte'
        />
        <meta
          name='keywords'
          content='Tattoo, Piercing, Stuttgart, Galerie, Instagram, Feed, Ausstellung, Sammlung, Collection, Stuttgart-Mitte, City, kurze Wartezeit, faire Preise, Franco Farao, Walk in, Termine online, Professionell, Profi, Tätowierer, Piercer, Make-up, Hair, Stylist, Schminken, Lippenstift, Wimpern, Augen, All Sexes, Tunnels, Tattoo Artist, Tübinger Strasse, Höchste Hygienestandards, Hygiene, Sicherheit, Corona-konform, Steril, Alle Stile, Cover-up, Flashes, Wannado, Intimpiercing, Qualität, Wohlfühlen, Komfort'
        />
        <meta
          property='og:title'
          content='Galerie – Otra Vida Tattoo & Piercing Stuttgart'
        />
        <meta
          property='og:description'
          content='Unsere Arbeiten, Professionelle Tattoos, Piercings, Haare & Make-up  in Stuttgart-Mitte'
        />
        <meta
          property='og:image'
          content='/assets/images/otra-vida_fb-image.png'
        />
        <title>Galerie – Otra Vida Tattoo & Piercing Stuttgart</title>
      </Helmet>
      <h1>Galerie</h1>
      <div className='flex-box flex-column' style={{ width: '100%' }}>
        <h3 style={{ marginBottom: 0 }}>360° Galerie Stuttgart</h3>
        <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', marginTop: '3rem' }}>
          <iframe
            src='https://www.google.com/maps/embed?pb=!4v1781553272956!6m8!1m7!1sCAoSHENJQUJJaENELWxicUEydHQxTzNua194TXRtQUQ.!2m2!1d48.77126548242741!2d9.173816905964978!3f140.22964590141387!4f-11.483389204158925!5f0.7820865974627469'
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
            allowFullScreen=''
            loading='lazy'
            referrerPolicy='no-referrer-when-downgrade'
          />
        </div>
      </div>
      <div className='feeds-box'>
        {_.map(photos, (media, index) => {
          return (
            <div className='gallery-location' key={index}>
              <h4>
                <LocationOn />
                {media.locationName}
              </h4>
              <div className='images-box'>
                {media.mediaArray &&
                  _.map(media.mediaArray, (data, key) => {
                    return (
                      data.type !== 'CAROUSEL_ALBUM' && (
                        <motion.div
                          initial={{ y: 200, opacity: 0 }}
                          animate={{ y: 0, opacity: 1 }}
                          transition={{
                            duration: 1,
                            ease: 'easeInOut',
                            delay: key * 0.2
                          }}
                          className='feed'
                          key={key}
                          disabled
                        >
                          {data.type === 'IMAGE' && (
                            <img
                              src={data.url}
                              alt={'Instagram'}
                              onClick={() => window.open(data.url)}
                            />
                          )}
                          {data.type === 'VIDEO' && (
                            <video
                              src={data.url}
                              alt={'Instagram'}
                              onClick={() => window.open(data.url)}
                              onMouseEnter={(e) => e.target.play()}
                              onMouseOut={(e) => e.target.pause()}
                            />
                          )}
                          <Instagram className='insta-logo' />
                        </motion.div>
                      )
                    );
                  })}
              </div>
              <button
                className='btn-primary'
                onClick={() =>
                  window.open(
                    `${
                      media.socialMedia.find(
                        (item) => item.name === 'Instagram'
                      ).url
                    }`
                  )
                }
              >
                Mehr Bilder
              </button>
            </div>
          );
        })}
      </div>
    </motion.section>
  );
};

export default GalleryComponent;
